//React
import React, { useEffect, useRef, useState } from "react";
//Components
import { Button, FlexBox, Image, Input, Screen } from "components";
//Styles
import "./styles.scss";
//Assets
import CalendarImg from "assets/calendar.svg";
import PoweredByOTPless from "assets/PoweredByOTPless.png";
import Logo from "assets/logo.svg";
//Utils
import { ChangeHistory, validateEmail } from "utils";
//Routes
import ROUTE_PATH from "Routes/paths";
//Toast
import { toast } from "react-toastify";
const Demo = () => {
  const [toInputValue, setToInputValue] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [orgData, setOrgData]: any = useState({});
  const [apiHit, setApiHit] = useState(false);
  const [emailSuccessModalVisibility, setEmailSuccessModalVisibility] =
    useState(false);
  const [toInputs, setToInputs]: any = useState([]);
  const toInputRef: any = useRef(null);
  const inputBlockRef: any = useRef(null);

  //Return UI
  return (
    <Screen className="help-screen pd-20">
      {/* <iframe src="https://mihit.authlink.me/getdata.html"></iframe> */}
      <FlexBox flexColumn justifyBetween alignCenter className="h-100">
        <Image src={Logo} className="main-logo" />
        <FlexBox
          flexColumn
          justifyEvenly
          alignCenter
          className="w-100 h-90 text-center"
        >
          <FlexBox
            flexColumn
            justifyCenter
            alignCenter
            className="calendar-block"
          >
            <Image src={CalendarImg} className="calendar-icon" />
            <p className="fs-20 font-heavy mr-t-20">Schedule an Expert call</p>
          </FlexBox>
          <form id="form_Id" className="w-100">
            <Input
              onChange={({ target }) => {
                setFirstName(target.value);
              }}
              inputRef={toInputRef}
              value={firstName}
              placeholder="Enter your first name"
              className="mr-b-20 fs-16"
              others={{
                id: "firstname",
                name: "firstname",
              }}
            />
            <Input
              onChange={({ target }) => {
                setLastName(target.value);
              }}
              value={lastName}
              placeholder="Enter your last name"
              className="mr-b-20 fs-16"
              others={{
                id: "lastname",
                name: "lastname",
              }}
            />
            <Input
              type="email"
              onChange={({ target }) => {
                setToInputValue(target.value);
              }}
              value={toInputValue}
              placeholder="Enter your email address"
              className="mr-b-20 fs-16"
              others={{
                id: "email",
                name: "email",
              }}
            />
            <Button
              text={apiHit ? <span className="spinner"></span> : "Schedule Now"}
              disabled={apiHit}
              onClick={() => {
                if (validateEmail(toInputValue)) {
                  window.ChiliPiper.submit("otpless", "tech_router", {
                    formId: "form_Id",
                  });
                } else {
                  toast.error("Please enter your work email address");
                }
              }}
              className="w-100"
            />
          </form>
        </FlexBox>
      </FlexBox>
    </Screen>
  );
};

export default Demo;
